var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.635 17.964l-31.5-13.5c-.285-.123-.586-.246-.884-.246-.606 0-1.202.246-1.638.707-.648.75-.797 1.768-.376 2.612L8.75 20.031 2.238 32.525A2.25 2.25 0 005.135 35.6l31.5-13.502A2.249 2.249 0 0038 20.03c-.064-.9-.535-1.715-1.365-2.066zM4.25 6.534c-.002 0 0-.002 0 0l28.878 12.372h-22.43L4.25 6.533zm-.017 27.032l6.465-12.41h22.367L4.231 33.566z",
    fill: "currentColor"
  })));
}
export default SvgSendMessage;